import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchTournamentsByQueryAPI } from "./tournamentSearchAPI";
import { showModal } from "../statusModal/statusModal";

const initialState = {
  cache: {},
  results: [],
  status: "idle",
  error: null,
};

export const fetchTournamentsByQuery = createAsyncThunk(
  "tournaments/fetchTournamentByQuery",
  async (query, { dispatch, rejectWithValue }) => {
    try {
      const data = await fetchTournamentsByQueryAPI(query);
      dispatch(
        showModal({
          message: "تم جلب بيانات البطولات بنجاح",
          status: "success",
        })
      );
      return data;
    } catch (error) {
      dispatch(
        showModal({ message: "حصل خطأ اثناء جلب البيانات", status: "error" })
      );
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch admins"
      );
    }
  }
);

const tournamentSearchSlice = createSlice({
  name: "tournamentSearch",
  initialState,
  reducers: {
    resetSearchResults: (state) => {
      state.results = [];
    },
    updateResultsFromCache: (state, action) => {
      state.results = action.payload;
      state.status = "succeeded";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchTournamentsByQuery.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchTournamentsByQuery.fulfilled, (state, action) => {
        const { query, results } = action.payload;
        state.cache[query] = results;
        state.results = results;
        state.status = "succeeded";
      })
      .addCase(fetchTournamentsByQuery.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export const { resetSearchResults } = tournamentSearchSlice.actions;

export default tournamentSearchSlice.reducer;
